import { render, staticRenderFns } from "./UpdateAccountCertification.vue?vue&type=template&id=e33c777e&"
import script from "./UpdateAccountCertification.vue?vue&type=script&lang=js&"
export * from "./UpdateAccountCertification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports